import { FormElement, TeamRole } from "app/types";
import {
  IDefaultCustomization,
  IInviteVerification,
  ITeamForm,
  OnBoardingState,
  PLAN_TYPE,
  ProfileForm,
  SetupForm,
} from "../types";

export const defaultFormElement: FormElement = {
  value: "",
  error: "",
};
export const defaultDefaultCustomization: IDefaultCustomization = {
   agileDevelopmentAndSprints: true,
      epicsAndStories: true,
      releaseManagement: true,
};

export const defaultTeamForm: ITeamForm = {
  name: defaultFormElement,
  project: {
    name: defaultFormElement,
    defaultCustomization: {
      ...defaultDefaultCustomization,
    },
  },
  members: [
    {
      name: defaultFormElement,
      role: defaultFormElement,
    },
  ],
  plan: PLAN_TYPE.BUSINESS,
  coupon: defaultFormElement,
  isLoading: false,
  projectId: "",
  teamId: "",
  isMemberAdded: false,
  isProjectCreated: false,
};

export const defaultProfileForm: ProfileForm = {
  name: defaultFormElement,
  password: defaultFormElement,
  confirmPassword: defaultFormElement,
  timezone: defaultFormElement,
  isLoading: false,
};

export const defaultSetupForm: SetupForm = {
  companySize: defaultFormElement,
  referalSource: defaultFormElement,
  toolPreferences: { value: [] as string[], error: "" },
  isLoading: false,
  isTeamCreated: false,
};

export const defaultInviteVerification: IInviteVerification = {
  teamId: "",
  teamMemberId: "",
  projectIds: [] as string[],
  email: "",
  teamRole: TeamRole.NONE,
  isExistingUser: false,
  accessToken: "",
  refreshToken: "",
  teamName: "",
};

export const initialState: OnBoardingState = {
  profileForm: { ...defaultProfileForm },
  setupForm: { ...defaultSetupForm },
  onboardingList: {
    companySizes: [],
    referalSources: [],
    toolPreferences: [],
  },
  teamFormActiveIndex: 1,
  teamForm: { ...defaultTeamForm },
  inviteVerification: { ...defaultInviteVerification },
  isLoading: false,
  isButtonLoading: false,
};
